import { DashboardsAPI } from '@/API/Dashboards'
import type { AppDispatch, RootState } from '@/redux'
import { dashboardPanelsActions } from '@/redux/slice/dashboardPanelsSlice'

/**
 * Loads all panels for a dashboard from the backend.
 * Dispatches setPanels on success.
 * Guards against stale responses: if the active dashboard changes while the
 * request is in-flight, the response is discarded without updating state.
 */
export const loadPanels = (token: string, dashboardId: string) =>
  async (dispatch: AppDispatch, getState: () => RootState): Promise<void> => {
    dispatch(dashboardPanelsActions.setLoading(true))
    try {
      const resp = await DashboardsAPI.getDashboardPanels(token, dashboardId)

      // Discard stale response if the active dashboard changed while in-flight
      const currentId = getState().dashboards.selectedDashboard?.id
      if (currentId !== dashboardId) return

      if (resp.err || !resp.data) {
        dispatch(dashboardPanelsActions.setError(resp.err ?? 'Failed to load panels.'))
        return
      }
      dispatch(dashboardPanelsActions.setError(null))
      dispatch(dashboardPanelsActions.setPanels(resp.data.panels))
    } catch {
      dispatch(dashboardPanelsActions.setError('Failed to load panels.'))
    } finally {
      dispatch(dashboardPanelsActions.setLoading(false))
    }
  }
